import { render, staticRenderFns } from "./CheckpointStep.vue?vue&type=template&id=471d0f8b&scoped=true&"
import script from "./CheckpointStep.vue?vue&type=script&lang=js&"
export * from "./CheckpointStep.vue?vue&type=script&lang=js&"
import style0 from "./CheckpointStep.vue?vue&type=style&index=0&id=471d0f8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d0f8b",
  null
  
)

export default component.exports